import * as yup from 'yup'

import questionnaireResponsesSchema from './questionnaireResponsesSchema'

const exertionFormSchema = (t) =>
	yup.tuple([yup.object(), yup.object(), questionnaireResponsesSchema(t)])

export default exertionFormSchema
